module.exports = __webpack_public_path__ + "static/media/1-11.3b6d4683.mp3";